const file = state => state.file
const progress = state => state.progress

export default {
  file,
  progress
}
